import { JoeDomain, Schema } from "../../../../../@types";
import Name from "../../../../../../search/schema/components/Name";
import { enums } from "../../../../../../../shim/jsbridge";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const domain: Schema<JoeDomain> = {
  fields: [
    {
      name: "k_name",
      displayTitle: "Name",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.k_name,
            int_submission_analyzer: URLANALYZER
          }}
        />
      ),
      style: { width: "20%" }
    },
    {
      name: "k_ip",
      displayTitle: "IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.k_ip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      ),
      style: { width: "10%" }
    },
    {
      name: "k_active",
      displayTitle: "Active",
      sortable: true,
      component: d => <>{d.k_active}</>,
      style: { width: "8%" }
    },
    {
      name: "k_malicious",
      displayTitle: "Malicious",
      sortable: true,
      component: d => <>{d.k_malicious}</>,
      style: { width: "8%" }
    },
    {
      name: "k_reputation",
      displayTitle: "Reputation",
      sortable: true,
      component: d => <>{d.k_reputation}</>,
      style: { width: "10%" }
    }
  ]
};
